export enum EnumStatusAvaliacaoQuestionarioUG {
    concordo = 1,
    concordoParcialmente = 2,
    discordo = 3
}